import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphRegular } from '@helpers/typography';
import HighlightTitleStyles from '@stories/Components/Misc/HighlightTitle/HighlightTitle.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  position: relative;
  overflow: hidden;
`;
const Container = styled(SectionWrapper) `
  --paddingTop: 280px;

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
    padding-top: var(--paddingTop);
    padding-bottom: ${fluid(16, 48)};
  }

  &[data-type='engage'] {
    ${SectionWrapperStyles.Inner} {
      padding-bottom: ${fluid(115, 138)};
    }
  }
`;
const ContentContainer = styled.div `
  grid-column: 1 / span 12;
  order: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${from(Device.Tablet)} {
    order: 2;
    grid-column: 4 / span 6;
  }
`;
const TitleContainer = styled.div `
  ${HighlightTitleStyles.Title} {
    ${fonts.gotham.ultra};
    margin: 0 0 ${fluid(16, 24)};
    font-size: ${fluid(36, 60)};
    line-height: ${fluid(50, 80)};
    text-align: center;

    [data-type='engage'] & {
      ${fonts.neueGalano.extraBold};
    }
  }
`;
const Content = styled.div `
  ${paragraphRegular};
  ${contentStyles};

  text-align: center;
  margin-bottom: ${fluid(24, 40)};

  [data-type='engage'] & {
    ${fonts.plusJakarta.regular};
  }

  @media ${until(Device.Tablet)} {
    ${Container}:has(${() => ReadMore}[data-active='true']) & {
      margin-bottom: 0;
    }

    ${Container}[data-read-all='false'] & {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
const ReadMore = styled.button `
  ${ButtonReset};
  ${paragraphRegular};
  ${fonts.gotham.bold};
  text-decoration: underline;
  margin: 0 0 ${fluid(16, 24)};
  text-align: center;
  text-transform: 'lowercase';

  @media ${from(Device.Tablet)} {
    display: none;
  }

  [data-type='engage'] & {
    ${fonts.plusJakarta.bold};
  }

  &[data-active='false'] {
    opacity: 0;
    pointer-events: none;
    display: none;
  }
`;
const CTAsContainer = styled.div `
  display: flex;
  justify-content: center;
  grid-gap: ${fluid(8, 24)};
  flex-wrap: wrap;
  margin-bottom: 24px;
`;
const ImageContainerLeft = styled.div `
  position: relative;
  grid-column: 1 / span 6;
  order: 2;
  display: flex;
  align-items: flex-end;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 3;
    order: 1;
  }
`;
const ImageContainerRight = styled.div `
  position: relative;
  grid-column: 7 / span 6;
  order: 3;
  display: flex;
  align-items: flex-end;

  @media ${from(Device.Tablet)} {
    grid-column: 10 / span 3;
  }
`;
const Image = styled.img `
  ${imageCoverContainer(true)};
  object-fit: contain;
`;
const baseEngageStyles = css `
  --gradientColour: ${brand.engageGradient.lilacPink};
  width: ${fluid(102, 228)};
  height: ${fluid(224, 558)};
  position: absolute;
  border-radius: 1000px 1000px 0 0;
  background: var(--gradientColour);
  z-index: 0;

  [data-background='engage-green'] &,
  [data-background='engage-lime'] & {
    --gradientColour: ${brand.engageGradient.green};
  }

  [data-background='engage-teal'] &,
  [data-background='engage-sea-green'] &,
  [data-background='engage-sky'] & {
    --gradientColour: ${brand.engageGradient.teal};
  }

  [data-background='engage-purple'] & {
    --gradientColour: ${brand.engageGradient.purple};
  }

  [data-background='engage-yellow'] &,
  [data-background='engage-tangerine'] &,
  [data-background='engage-cream'] & {
    --gradientColour: ${brand.engageGradient.orangeYellow};
  }
`;
const EngageShapeRight = styled.div `
  ${baseEngageStyles};
  bottom: -15%;
  right: 5%;
  transform: rotate(-60deg);

  @media ${from(Device.Tablet)} {
    bottom: -20%;
    right: 10%;
    transform: rotate(30deg);
  }
`;
const EngageShapeLeft = styled.div `
  ${baseEngageStyles};
  bottom: -16%;
  left: -3%;
  transform: rotate(136deg);

  @media ${from(Device.Tablet)} {
    top: 15%;
    left: 0;
    transform: rotate(120deg);
  }
`;
const InnerHeroBannerStyles = {
    Wrapper,
    Container,
    ContentContainer,
    TitleContainer,
    Content,
    ReadMore,
    CTAsContainer,
    ImageContainerLeft,
    ImageContainerRight,
    Image,
    EngageShapeRight,
    EngageShapeLeft,
};
export default InnerHeroBannerStyles;
